import { COLUMN_TYPE } from "utils/constants";

export interface DeviceDirectoryQuery {
  page: number;
  pageSize: number;
  all?: boolean;
  sortBy?: string;
  sortOrder?: string;
  filterColumn?: string;
  filterType?: string;
  filterValue?: unknown;
}

export type DeviceDirectoryParams = Record<string, string | number | boolean>;

const toUtcTimestamp = (value: unknown): string => {
  const date = new Date(value as string | number | Date);
  if (Number.isNaN(date.getTime())) return "";

  return date.toISOString().slice(0, 19).replace("T", " ");
};

export const buildDeviceDirectoryParams = (query: DeviceDirectoryQuery): DeviceDirectoryParams => {
  const params: DeviceDirectoryParams = {
    page: query.page,
    pageSize: query.pageSize,
  };

  if (query.all) params.all = true;
  if (query.sortBy) params.sortBy = query.sortBy;
  if (query.sortOrder) params.sortOrder = query.sortOrder;

  if (!query.filterColumn || !query.filterType || query.filterValue === undefined) {
    return params;
  }

  params.filterColumn = query.filterColumn;
  params.filterType = query.filterType;

  if (query.filterType === COLUMN_TYPE.DATE) {
    const dateRange = query.filterValue as { startDate?: unknown; endDate?: unknown };
    const filterStart = toUtcTimestamp(dateRange.startDate);
    const filterEnd = toUtcTimestamp(dateRange.endDate);

    if (filterStart && filterEnd) {
      params.filterStart = filterStart;
      params.filterEnd = filterEnd;
    }
  } else {
    params.filterValue = String(query.filterValue);
  }

  return params;
};

export const buildDeviceDirectoryPath = (query: DeviceDirectoryQuery): string => {
  const params = buildDeviceDirectoryParams(query);
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => searchParams.set(key, String(value)));

  return `eiStatusUIHook?${searchParams.toString()}`;
};
